import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Button, Modal } from '@material-ui/core';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import SearchButton from '../../components/atoms/SearchButton';
// import ESSearchButton from '../../components/atoms/ESSearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
// import CsvDownloadEsButton from '../../components/atoms/CsvDownloadEsButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import GochiHistoryTable from '../organisms/GochiHistoryTable';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGochis,
  downloadGochi,
  getGochisEs,
  downloadGochiEs,
  updateAmountEducationSystem,
  getUpdateAmountHistoryDetail,
  getRemainAmountUpdateAmount,
  UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS,
  GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS,
  GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS
} from '../../actions/Gochis';
import depositPlans from '../../constants/DepositPlan';
import UpdateAmountConfirmModal from '../organisms/UpdateAmountConfirmModal';
import UpdateAmountSuccessModal from '../organisms/UpdateAmountSuccessModal';
import UpdateAmountModal from '../organisms/UpdateAmountModal';
import UpdateAmountHistoryModal from '../organisms/UpdateAmountHistoryModal';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  textNoteClassicCsv: {
    fontSize: 12,
    width: 220,
    marginLeft: 'auto',
    textAlign: 'left'
  },
  textLinkCsv: {
    color: '#2196F3'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      gochiTypes: state.gochis.gochiTypes,
      gochiUserTypes: state.gochis.gochiUserTypes,
      gochiStatuses: state.gochis.gochiStatuses
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochis,
          downloadGochi,
          getGochisEs,
          downloadGochiEs,
          updateAmountEducationSystem,
          getUpdateAmountHistoryDetail,
          getRemainAmountUpdateAmount
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupName', 'setGroupName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuId', 'setMenuId', ''),
  withState('address', 'setAddress', ''),
  withState('menuName', 'setMenuName', ''),
  withState('userEmail', 'setUserEmail', ''),
  withState('userName', 'setUserName', ''),
  withState('gochiType', 'setGochiType', ''),
  withState('gochiUserType', 'setGochiUserType', ''),
  withState('isShashoku', 'setIsShashoku', false),
  withState('gochiDateFrom', 'setGochiDateFrom', ''),
  withState('gochiDateTo', 'setGochiDateTo', ''),
  withState('gochiStatus', 'setGochiStatus', ''),
  withState('gochiUseDateFrom', 'setGochiUseDateFrom', ''),
  withState('depositPlan', 'setDepositPlan', ''),
  withState('gochiUseDateTo', 'setGochiUseDateTo', ''),
  withState('gochiUseDateEnableFlg', 'setGochiUseDateEnableFlg', true),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('shopId', 'setShopId', ''),
  withState('gochiBillNo', 'setGochiBillNo', ''),
  withState('searchEs', 'setSearchEs', false),
  withState('isGochiKid', 'setIsGochiKid', false),
  // withState('useForShopId', 'setUseForShopId', ''),
  // withState('useForShopName', 'setUseForShopName', ''),
  withState('showUpdateAmountModal', 'setShowUpdateAmountModal', false),
  withState(
    'showUpdateAmountConfirmModal',
    'setShowUpdateAmountConfirmModal',
    false
  ),
  withState(
    'showUpdateAmountSuccessModal',
    'setShowUpdateAmountSuccessModal',
    false
  ),
  withState('gochiChoseUpdateAmount', 'setGochiChoseUpdateAmount', null),
  withState(
    'couponGochiChoseUpdateAmount',
    'setCouponGochiChoseUpdateAmount',
    null
  ),
  withState(
    'systemNameGochiChoseUpdateAmount',
    'setSystemNameGochiChoseUpdateAmount',
    ''
  ),
  withState('oldAmountUpdateAmount', 'setOldAmountUpdateAmount', null),
  withState('maxAmountCanUpdate', 'setMaxAmountCanUpdate', 0),
  withState('amountUpdated', 'setAmountUpdated', null),
  withState('amountUpdatedError', 'setAmountUpdatedError', ''),
  withState('crfsToken', 'setCrfsToken', ''),
  withState(
    'showUpdateAmountHistoryModal',
    'setShowUpdateAmountHistoryModal',
    false
  ),
  withState('updateAmountHistoryDetail', 'setUpdateAmountHistoryDetail', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      // if (props.searchEs) {
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        groupName: props.groupName,
        shopName: props.shopName,
        address: props.address,
        menuName: props.menuName,
        userEmail: props.userEmail,
        userName: props.userName,
        gochiType: props.gochiType,
        gochiUserType: props.gochiUserType,
        gochiDateFrom: props.gochiDateFrom,
        gochiDateTo: props.gochiDateTo,
        gochiStatus: props.gochiStatus,
        gochiUseDateFrom: props.gochiUseDateFrom,
        depositPlan: props.depositPlan,
        gochiUseDateTo: props.gochiUseDateTo,
        gochiBillNo: props.gochiBillNo,
        shopId: props.shopId,
        menuId: props.menuId,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      if (props.searchEs) {
        props.actions
          .getGochisEs(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(e => {
            console.log('error search ES', e);
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      } else {
        props.actions
          .getGochis(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(e => {
            console.log('error search gochi', e);
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      }
      // }
      props.setPage(page);
    },
    handleDeleteGochi: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      props.updateLoading(true);
      props.updateOpenProgress(true);

      if (props.searchEs) {
        const rowsPerPage = document.getElementById('rowsPerPage');
        let limitNum = 100;
        if (rowsPerPage) {
          limitNum = rowsPerPage.textContent;
        }
        const searchKey = {
          groupName: props.groupName,
          shopName: props.shopName,
          address: props.address,
          menuName: props.menuName,
          userEmail: props.userEmail,
          userName: props.userName,
          gochiType: props.gochiType,
          gochiUserType: props.gochiUserType,
          gochiDateFrom: props.gochiDateFrom,
          gochiDateTo: props.gochiDateTo,
          gochiStatus: props.gochiStatus,
          gochiUseDateFrom: props.gochiUseDateFrom,
          depositPlan: props.depositPlan,
          gochiUseDateTo: props.gochiUseDateTo,
          gochiBillNo: props.gochiBillNo,
          shopId: props.shopId,
          menuId: props.menuId,
          page,
          limit: limit || limitNum
        };

        props.actions
          .getGochisEs(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(() => {
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      } else {
        const searchKey = {
          groupName: props.groupName,
          shopName: props.shopName,
          address: props.address,
          menuName: props.menuName,
          userEmail: props.userEmail,
          userName: props.userName,
          gochiType: props.gochiType,
          gochiUserType: props.gochiUserType,
          gochiDateFrom: props.gochiDateFrom,
          gochiDateTo: props.gochiDateTo,
          gochiStatus: props.gochiStatus,
          gochiUseDateFrom: props.gochiUseDateFrom,
          depositPlan: props.depositPlan,
          gochiUseDateTo: props.gochiUseDateTo,
          gochiBillNo: props.gochiBillNo,
          shopId: props.shopId,
          menuId: props.menuId
        };

        props.actions
          .getGochis(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              props.updateOpenProgress(false);
              props.setResultMessage('');
              props.updateLoading(false);
              props.updateOpenTable(true);
            } else {
              props.setResultMessage('ごち検索に失敗しました。');
              props.updateLoading(false);
            }
          })
          .catch(() => {
            props.updateOpenProgress(true);
            props.setResultMessage('ごち検索に失敗しました。');
            props.updateLoading(false);
          });
      }
    },
    generateRandomString: props => (length = 32) => {
      let text = '';
      const possible =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (let i = 0; i < length; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      console.log('crfs token', text);
      props.setCrfsToken(text);
      return text;
    }
  }),
  lifecycle({
    async componentDidMount() {
      isAuthenticated(this.props);
      this.props.generateRandomString();
      //  const gochiDateParam = {
      //    gochiDateFrom: this.props.gochiDateFrom,
      //    gochiDateTo: this.props.gochiDateTo,
      //    page: this.props.page,
      //    limit: this.props.rowsPerPage
      //  };
      //  this.props.updateLoading(true);
      //  this.props.updateOpenProgress(true);
      //  await this.props.actions.getGochis(gochiDateParam).then(data => {
      //    this.props.checkSession(data);
      //    if (data.type === 'GET_GOCHIS_SUCCESS') {
      //      this.props.updateOpenTable(true);
      //      this.props.updateOpenProgress(false);
      //      this.props.updateLoading(false);
      //      // this.props.handleChangePage(null, 0);
      //    } else {
      //      this.props.setResultMessage('ごち検索に失敗しました。');
      //      this.props.updateLoading(false);
      //    }
      //  });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    handleDeleteGochi,
    account,
    gochiTypes,
    gochiUserTypes,
    gochiStatuses,
    openDrawer,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    groupName,
    setGroupName,
    shopName,
    setShopName,
    address,
    setAddress,
    menuName,
    setMenuName,
    userEmail,
    setUserEmail,
    userName,
    setUserName,
    gochiType,
    setGochiType,
    gochiBillNo,
    setGochiBillNo,
    // useForShopId,
    // setUseForShopId,
    // useForShopName,
    // setUseForShopName,
    gochiUserType,
    setGochiUserType,
    gochiDateFrom,
    setGochiDateFrom,
    gochiDateTo,
    setGochiDateTo,
    gochiStatus,
    setGochiStatus,
    gochiUseDateFrom,
    setGochiUseDateFrom,
    depositPlan,
    setDepositPlan,
    gochiUseDateTo,
    setGochiUseDateTo,
    gochiUseDateEnableFlg,
    setGochiUseDateEnableFlg,
    page,
    shopId,
    setShopId,
    menuId,
    setMenuId,
    searchEs,
    setSearchEs,
    setPage,
    isShashoku,
    setIsShashoku,
    isGochiKid,
    setIsGochiKid,
    showUpdateAmountModal,
    setShowUpdateAmountModal,
    gochiChoseUpdateAmount,
    setGochiChoseUpdateAmount,
    couponGochiChoseUpdateAmount,
    setCouponGochiChoseUpdateAmount,
    systemNameGochiChoseUpdateAmount,
    setSystemNameGochiChoseUpdateAmount,
    oldAmountUpdateAmount,
    setOldAmountUpdateAmount,
    maxAmountCanUpdate,
    setMaxAmountCanUpdate,
    amountUpdated,
    setAmountUpdated,
    amountUpdatedError,
    setAmountUpdatedError,
    showUpdateAmountConfirmModal,
    setShowUpdateAmountConfirmModal,
    showUpdateAmountSuccessModal,
    setShowUpdateAmountSuccessModal,
    crfsToken,
    generateRandomString,
    showUpdateAmountHistoryModal,
    setShowUpdateAmountHistoryModal,
    updateAmountHistoryDetail,
    setUpdateAmountHistoryDetail,
    history
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 100;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }

    const searchKey = {
      groupName,
      shopName,
      address,
      menuName,
      userEmail,
      userName,
      gochiType,
      gochiUserType,
      gochiDateFrom,
      gochiDateTo,
      gochiStatus,
      gochiUseDateFrom,
      depositPlan,
      gochiUseDateTo,
      gochiBillNo,
      // useForShopId,
      // useForShopName,
      shopId,
      menuId,
      limit
    };

    const searchAction = async () => {
      // updateOpenTable(true);
      // const rowsPerPage = document.getElementById('rowsPerPage');
      // let limitNum = 100;
      // if (rowsPerPage) {
      //   limitNum = rowsPerPage.textContent;
      // }
      // handleChangePage(null, 1, limitNum);
      if (gochiDateFrom || gochiDateTo || gochiUseDateFrom || gochiUseDateTo) {
        updateLoading(true);
        updateOpenProgress(true);
        setPage(1);
        await actions
          .getGochis(searchKey)
          .then(data => {
            checkSession(data);
            if (data.type === 'GET_GOCHIS_SUCCESS') {
              updateOpenProgress(false);
              setResultMessage('');
              updateLoading(false);
              // handleChangePage(null, 0);
              updateOpenTable(true);
              setSearchEs(false);
            } else {
              setResultMessage('ごち検索に失敗しました。');
              updateLoading(false);
            }
          })
          .catch(() => {
            updateOpenProgress(true);
            setResultMessage('ごち検索に失敗しました。');
            updateLoading(false);
          });
      } else {
        updateOpenProgress(true);
        setResultMessage('購入日または使用日を入力してください');
      }
    };

    // const searchEsAction = async () => {
    //   // updateOpenTable(true);
    //   // const rowsPerPage = document.getElementById('rowsPerPage');
    //   // let limitNum = 100;
    //   // if (rowsPerPage) {
    //   //   limitNum = rowsPerPage.textContent;
    //   // }
    //   // handleChangePage(null, 1, limitNum);
    //   updateLoading(true);
    //   updateOpenProgress(true);
    //   await actions
    //     .getGochisEs(searchKey)
    //     .then(data => {
    //       checkSession(data);
    //       if (data.type === 'GET_GOCHIS_SUCCESS') {
    //         updateOpenProgress(false);
    //         setResultMessage('');
    //         updateLoading(false);
    //         // handleChangePage(null, 0);
    //         updateOpenTable(true);
    //         setSearchEs(true);
    //       } else {
    //         setResultMessage('ごち検索に失敗しました。');
    //         updateLoading(false);
    //       }
    //     })
    //     .catch(() => {
    //       updateOpenProgress(true);
    //       setResultMessage('ごち検索に失敗しました。');
    //       updateLoading(false);
    //     });
    // };

    const downloadCsvBlob = (blob, fileName, isZipP) => {
      const blobC = new Blob([blob], {
        type: isZipP ? 'application/zip' : 'text/csv'
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blobC, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blobC);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async isZipP => {
      if (gochiDateFrom || gochiDateTo || gochiUseDateFrom || gochiUseDateTo) {
        updateLoading(true);
        updateOpenProgress(true);
        let fileType = '';
        const params = { ...searchKey };

        if (isZipP) {
          params.isZip = 1;
          fileType = '.csv.zip';
        } else {
          params.isZip = 0;
          fileType = '.csv';
        }

        const response = await actions
          .downloadGochi(params)
          .then(data => checkSession(data))
          .catch(() => {
            updateOpenProgress(true);
            setResultMessage(
              'ファイル容量が想定量を超えたため、ダウンロードに失敗しました。\n恐れ入りますが、期間を短く設定し直してから再度ダウンロードを実行ください。'
            );
            updateLoading(false);
          });
        if (response && response.type === 'DOWNLOAD_GOCHIS_SUCCESS') {
          const timeStamp = moment()
            .tz('Asia/Tokyo')
            .format('YYYYMMDDHHmm');
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
          downloadCsvBlob(
            response.payload,
            `${timeStamp}_gochi_info${fileType}`,
            isZipP
          );
        } else {
          updateOpenProgress(true);
          setResultMessage(
            'ファイル容量が想定量を超えたため、ダウンロードに失敗しました。\n恐れ入りますが、期間を短く設定し直してから再度ダウンロードを実行ください。'
          );
          updateLoading(false);
        }
      } else {
        updateOpenProgress(true);
        setResultMessage('購入日または使用日を入力してください');
      }
    };

    // const csvDownloadEsAction = async () => {
    //   updateLoading(true);
    //   updateOpenProgress(true);
    //   const response = await actions
    //     .downloadGochiEs(searchKey)
    //     .then(data => checkSession(data));
    //   if (response.type === 'DOWNLOAD_GOCHIS_ES_SUCCESS') {
    //     const timeStamp = moment()
    //       .tz('Asia/Tokyo')
    //       .format('YYYYMMDDHHmm');
    //     updateOpenProgress(false);
    //     setResultMessage('');
    //     updateLoading(false);
    //     downloadCsvBlob(response.payload, `${timeStamp}_gochi_info.csv`);
    //   } else {
    //     setResultMessage('ごち情報ダウンロードに失敗しました。');
    //     updateLoading(false);
    //   }
    // };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const handleChangeGochiType = e => {
      setGochiType(e);
      if (e === 'SHASHOKU') {
        setIsShashoku(true);
        setGochiDateFrom('');
        setGochiDateTo('');
        setGochiUserType('');
        setGochiBillNo('');
      } else if (e === 'GOCHI_KID') {
        setIsGochiKid(true);
        setGochiDateFrom('');
        setGochiDateTo('');
        setGochiUserType('');
        setGochiBillNo('');
      } else {
        setIsShashoku(false);
        setIsGochiKid(false);
      }
    };

    const openUpdateAmountModal = async (gochi, coupon) => {
      updateLoading(true);
      updateOpenProgress(true);
      let params = null;

      if (gochi.sourceTable === 'SHASHOKU') {
        params = {
          shashokuTicketId: gochi.shashokuTicketId,
          couponId: null
        };
      } else if (
        gochi.sourceTable === 'GOCHI' &&
        gochi.gochiTypeStr === gochiTypes[4].name
      ) {
        params = {
          shashokuTicketId: null,
          couponId: coupon.couponId
        };
      }

      const response = await actions
        .getRemainAmountUpdateAmount(params)
        .then(data => checkSession(data));

      if (response.type === GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS) {
        updateLoading(false);
        updateOpenProgress(false);
        setGochiChoseUpdateAmount(gochi);
        setAmountUpdatedError('');
        setSystemNameGochiChoseUpdateAmount(response.payload.eduSystem);

        if (gochi.sourceTable === 'SHASHOKU') {
          setCouponGochiChoseUpdateAmount(null);
          setOldAmountUpdateAmount(gochi.amountTransferToShopWhenUseShashoku);
          setMaxAmountCanUpdate(
            gochi.amountTransferToShopWhenUseShashoku +
              (response.payload.remainAmount !== null
                ? response.payload.remainAmount
                : 0)
          );

          if (gochi.menuId) {
            setAmountUpdated(0);
            generateRandomString();
            setShowUpdateAmountConfirmModal(true);
          } else {
            setAmountUpdated(null);
            setShowUpdateAmountModal(true);
          }
        } else if (
          gochi.sourceTable === 'GOCHI' &&
          gochi.gochiTypeStr === gochiTypes[4].name
        ) {
          setAmountUpdated(null);
          setShowUpdateAmountModal(true);
          setCouponGochiChoseUpdateAmount(coupon);
          setOldAmountUpdateAmount(coupon.amountTransferToShopWhenUse);
          setMaxAmountCanUpdate(
            coupon.amountTransferToShopWhenUse +
              (response.payload.remainAmount !== null
                ? response.payload.remainAmount
                : 0)
          );
        }
      } else {
        updateLoading(false);
        setResultMessage('エラーが発生しました！');
      }
    };

    const validAmountUpdated = () => {
      const value = amountUpdated;
      if (value === '') {
        setAmountUpdatedError('必須項目です。');
        return 1;
      }

      if (!/^\d+$/.test(value)) {
        setAmountUpdatedError('半角数字のみ入力してください。');
        return 1;
      }

      if (parseInt(value, 10) === oldAmountUpdateAmount) {
        setAmountUpdatedError('修正金額を正しく入力してください。');
        return 1;
      }

      if (parseInt(value, 10) > maxAmountCanUpdate) {
        setAmountUpdatedError(
          `ユーザーの残金を超えて増額は不可です\nユーザー残金：${maxAmountCanUpdate.toLocaleString()}円`
        );
        return 1;
      }

      setAmountUpdatedError('');
      setAmountUpdated(parseInt(value, 10));
      return 0;
    };

    const confirmUpdateAmount = () => {
      let errorCount = 0;
      errorCount = validAmountUpdated();

      if (errorCount === 0) {
        setShowUpdateAmountModal(false);
        generateRandomString();
        setShowUpdateAmountConfirmModal(true);
      }
    };

    const backConfirmUpdateAmount = () => {
      setShowUpdateAmountConfirmModal(false);

      if (
        (gochiChoseUpdateAmount.sourceTable === 'SHASHOKU' &&
          !gochiChoseUpdateAmount.menuId) ||
        (gochiChoseUpdateAmount.sourceTable === 'GOCHI' &&
          gochiChoseUpdateAmount.gochiTypeStr === gochiTypes[4].name)
      ) {
        setShowUpdateAmountModal(true);
      }
    };

    const editAmountEducationSystem = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      let params = null;

      if (gochiChoseUpdateAmount.sourceTable === 'SHASHOKU') {
        params = {
          shashokuTicketId: gochiChoseUpdateAmount.shashokuTicketId,
          couponId: null,
          newAmount: amountUpdated
        };
      } else if (
        gochiChoseUpdateAmount.sourceTable === 'GOCHI' &&
        gochiChoseUpdateAmount.gochiTypeStr === gochiTypes[4].name
      ) {
        params = {
          shashokuTicketId: null,
          couponId: couponGochiChoseUpdateAmount.couponId,
          newAmount: amountUpdated
        };
      }

      const response = await actions
        .updateAmountEducationSystem(params, crfsToken)
        .then(data => checkSession(data));

      if (response.type === UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS) {
        generateRandomString();
        setShowUpdateAmountSuccessModal(true);
        setShowUpdateAmountConfirmModal(false);
        updateLoading(false);
        updateOpenProgress(false);
      } else {
        updateLoading(false);
        if (
          response.error &&
          response.payload.data &&
          response.payload.data.errorInfo &&
          response.payload.data.errorInfo.code ===
            'exception.errors.security.has.csrf.token'
        ) {
          generateRandomString();
          setResultMessage('処理中ですのでしばらくお待ちください。');
        } else {
          setResultMessage('エラーが発生しました！');
        }
      }
    };

    const handleCloseUpdateAmountSuccessModal = () => {
      console.log(page);
      handleChangePage(null, page, null);
      setShowUpdateAmountSuccessModal(false);
    };

    const openUpdateAmountHistory = async (couponId, shashokuTicketId) => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .getUpdateAmountHistoryDetail({ couponId, shashokuTicketId })
        .then(data => checkSession(data));

      if (response.type === GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS) {
        setUpdateAmountHistoryDetail(response.payload);
        setShowUpdateAmountHistoryModal(true);
        updateLoading(false);
        updateOpenProgress(false);
      } else {
        updateLoading(false);
        setResultMessage('エラーが発生しました！');
      }
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            ごち検索
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            {(roles.isGroup || roles.isSecretariat || roles.isDeveloper) && (
              <div>
                {(roles.isGroup ||
                  roles.isSecretariat ||
                  roles.isDeveloper) && (
                  <TextField
                    label="店舗ID"
                    placeholder="店舗ID"
                    type="search"
                    className={classes.textField}
                    margin="normal"
                    value={shopId}
                    onChange={e => {
                      setShopId(e.target.value);
                    }}
                  />
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TextField
                    label="グループ名"
                    placeholder="部分一致"
                    type="search"
                    className={classes.textField}
                    margin="normal"
                    value={groupName}
                    onChange={e => {
                      setGroupName(e.target.value);
                    }}
                  />
                )}
                {(roles.isGroup ||
                  roles.isSecretariat ||
                  roles.isDeveloper) && (
                  <TextField
                    label="店舗名"
                    placeholder="部分一致"
                    type="search"
                    className={classes.textField}
                    margin="normal"
                    value={shopName}
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                  />
                )}
                {(roles.isGroup ||
                  roles.isSecretariat ||
                  roles.isDeveloper) && (
                  <TextField
                    label="住所"
                    placeholder="部分一致"
                    type="search"
                    className={classes.textField}
                    margin="normal"
                    value={address}
                    onChange={e => {
                      setAddress(e.target.value);
                    }}
                  />
                )}
              </div>
            )}
            <div>
              <TextField
                label="メニュー名"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={menuName}
                onChange={e => {
                  setMenuName(e.target.value);
                }}
              />
              <TextField
                label="メニューID"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={menuId}
                onChange={e => {
                  setMenuId(e.target.value);
                }}
              />
              <TextField
                select
                label="チケット種別"
                className={classes.textField}
                margin="normal"
                value={gochiType}
                onChange={e => {
                  handleChangeGochiType(e.target.value);
                }}
                InputLabelProps={{
                  shrink: true
                }}
              >
                {gochiTypes.map(type => {
                  return (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                select
                label="使用者種別"
                className={classes.textField}
                margin="normal"
                disabled={isShashoku || isGochiKid}
                value={gochiUserType}
                onChange={e => {
                  setGochiUserType(e.target.value);
                }}
                InputLabelProps={{
                  shrink: true
                }}
              >
                {gochiUserTypes.map(type => {
                  return (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </div>
            <div>
              <TextField
                label="メールアドレス"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={userEmail}
                onChange={e => {
                  setUserEmail(e.target.value);
                }}
              />
              <TextField
                label="購入者名"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={userName}
                onChange={e => {
                  setUserName(e.target.value);
                }}
              />
              <TextField
                label="領収書NO"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                disabled={isShashoku || isGochiKid}
                value={gochiBillNo}
                onChange={e => {
                  setGochiBillNo(e.target.value);
                }}
              />
            </div>
            {/* <div>
              <TextField
                label="使用された店舗ID"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={useForShopId}
                onChange={e => {
                  setUseForShopId(e.target.value);
                }}
              />
              <TextField
                label="使用された店舗名"
                placeholder="部分一致"
                type="search"
                className={classes.textField}
                margin="normal"
                value={useForShopName}
                onChange={e => {
                  setUseForShopName(e.target.value);
                }}
              />
            </div> */}
            <div>
              <TextField
                label="購入日(From)"
                type="date"
                className={classes.textField150}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                disabled={isShashoku || isGochiKid}
                value={gochiDateFrom}
                onChange={e => {
                  setGochiDateFrom(e.target.value);
                }}
              />
              <TextField
                label="購入日(To)"
                type="date"
                className={classes.textField150}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                disabled={isShashoku || isGochiKid}
                value={gochiDateTo}
                onChange={e => {
                  setGochiDateTo(e.target.value);
                }}
              />
            </div>
            <div>
              <TextField
                select
                label="使用状況"
                className={classes.textField}
                margin="normal"
                value={gochiStatus}
                onChange={e => {
                  setGochiStatus(e.target.value);
                  if (e.target.value === '' || e.target.value === 'USED') {
                    setGochiUseDateEnableFlg(true);
                  } else {
                    setGochiUseDateFrom('');
                    setGochiUseDateTo('');
                    setGochiUseDateEnableFlg(false);
                  }
                }}
                InputLabelProps={{
                  shrink: true
                }}
              >
                {gochiStatuses.map(status => {
                  return (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                label="使用日(From)"
                type="date"
                className={classes.textField150}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                disabled={!gochiUseDateEnableFlg}
                value={gochiUseDateFrom}
                onChange={e => {
                  setGochiUseDateFrom(e.target.value);
                }}
              />
              <TextField
                label="使用日(To)"
                type="date"
                className={classes.textField150}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                disabled={!gochiUseDateEnableFlg}
                value={gochiUseDateTo}
                onChange={e => {
                  setGochiUseDateTo(e.target.value);
                }}
              />
              <TextField
                select
                label="入金予定"
                className={classes.textField}
                margin="normal"
                value={depositPlan}
                onChange={e => {
                  setDepositPlan(e.target.value);
                }}
                InputLabelProps={{
                  shrink: true
                }}
              >
                {depositPlans.map(plan => {
                  return (
                    <MenuItem key={plan.id} value={plan.id}>
                      {plan.name}
                    </MenuItem>
                  );
                })}
              </TextField>
            </div>
            <div className={classes.buttonLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
            <div className={classes.buttonRight}>
              <Button
                variant="outlined"
                color="primary"
                style={{ margin: '5px 5px' }}
                onClick={() => {
                  history.push('/update_amount_history');
                }}
              >
                金額修正履歴
              </Button>
              <CsvDownloadButton
                title="検索結果出力（CSV形式）"
                onClickAction={() => {
                  csvDownloadAction(false);
                }}
              />
              <CsvDownloadButton
                title="検索結果出力（ZIP形式）"
                onClickAction={() => {
                  csvDownloadAction(true);
                }}
              />
            </div>
          </div>
          {openTable && (
            <GochiHistoryTable
              roles={roles}
              page={page}
              handleChangePage={handleChangePage}
              handleDeleteGochi={handleDeleteGochi}
              selectedPage={page}
              searchEs={searchEs}
              openUpdateAmountModal={openUpdateAmountModal}
              openUpdateAmountHistory={openUpdateAmountHistory}
            />
          )}
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <div>
          <Modal
            open={showUpdateAmountModal}
            className={classes.modalMobile}
            onClose={() => {
              setShowUpdateAmountModal(false);
            }}
          >
            <UpdateAmountModal
              amountUpdated={amountUpdated}
              setAmountUpdated={setAmountUpdated}
              validAmountUpdated={validAmountUpdated}
              amountUpdatedError={amountUpdatedError}
              confirmUpdateAmount={confirmUpdateAmount}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountConfirmModal}
            className={classes.modalMobile}
            onClose={() => {
              backConfirmUpdateAmount();
            }}
          >
            <UpdateAmountConfirmModal
              amountUpdated={amountUpdated}
              editAmountEducationSystem={editAmountEducationSystem}
              backConfirmUpdateAmount={backConfirmUpdateAmount}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
              isAdmin
              systemNameGochiChoseUpdateAmount={
                systemNameGochiChoseUpdateAmount
              }
              oldAmountUpdateAmount={oldAmountUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountSuccessModal}
            className={classes.modalMobile}
            onClose={() => {
              handleCloseUpdateAmountSuccessModal();
            }}
          >
            <UpdateAmountSuccessModal
              amountUpdated={amountUpdated}
              gochiChoseUpdateAmount={gochiChoseUpdateAmount}
              handleCloseUpdateAmountSuccessModal={
                handleCloseUpdateAmountSuccessModal
              }
              oldAmountUpdateAmount={oldAmountUpdateAmount}
            />
          </Modal>
        </div>

        <div>
          <Modal
            open={showUpdateAmountHistoryModal}
            className={classes.modalMobile}
            onClose={() => {
              setShowUpdateAmountHistoryModal(false);
            }}
          >
            <UpdateAmountHistoryModal
              setShowUpdateAmountHistoryModal={setShowUpdateAmountHistoryModal}
              updateAmountHistoryDetail={updateAmountHistoryDetail}
            />
          </Modal>
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main)); // <ESSearchButton onClickAction={searchEsAction} /> <CsvDownloadEsButton onClickAction={csvDownloadEsAction} />
